
import { defineComponent, toRef, ref } from 'vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'CodeBlock',

  props: {
    // eslint-disable-next-line vue/no-unused-properties
    label: {
      type: String,
      required: false,
      default: null,
    },

    // eslint-disable-next-line vue/no-unused-properties
    content: {
      type: String,
      required: true,
    },

    showCopyButton: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  setup(props) {
    const { t } = useI18n();
    const codeLabel = toRef(props, 'label');
    const code = toRef(props, 'content');
    const isCopied = ref(false);

    const copyToClipboard = () => {
      const rawContent = code.value;

      const contentToCopy = typeof rawContent === 'object'
        ? JSON.stringify(rawContent, null, 2)
        : String(rawContent);

      navigator.clipboard.writeText(contentToCopy)
        .then(() => {
          isCopied.value = true;
          setTimeout(() => {
            isCopied.value = false;
          }, 1000);
        })
        .catch(() => {
          // silencieux
        });
    };

    return {
      t,
      codeLabel,
      code,
      copyToClipboard,
      isCopied,
    };
  },
});
